<template>
  <pro-list-frame
    ref="plTable"
    :title="(titleProp ? $t(titleProp) : $t($route.name, { name: $store.state.studentLabel }))"
    icon="mdi-account-group-outline"
    :total="totalItems"
    :rows="items.length"
    :search.sync="search"
    :columns="toggleableHeaders"
    :hidden="hiddenColumns"
    :selected-count="selected.length"
    :loading="loading"
    :cell-sel="cellSel"
    :fixed="!mobileShow"
    :create-label="(!mobileShow) ? $t(personnel == 'active' ? $t('new-user') : $t('newCustomer')) : ''"
    @refresh="getItems"
    @filter="filter = true"
    @print="printStudio = true"
    @create="
          $router.push({
            name: 'customer',
            params: {
              personnelStatus: personnel,
              tabName: personnel === 'active' ? $t('new-user') : $t('newCustomer'),
            },
          })
        "
    @toggle-column="toggleColumn"
    @show-all-columns="hiddenColumns = []"
    @cell-down="onCellDown"
    @cell-over="onCellOver"
    @clear-cells="clearCellSel"
    @clear-selection="selected = []"
  >
    <template #tools>
      <export-excel
        ref="refExcel"
        :data="excelItems"
        worksheet="abriron.com"
        name="data-ai.xls"
        type="xls"
        :title="$store.state.abrName"
        :total-prop="pageCount"
        :page-prop="excelPage"
        @getAllRows="getAllRows"
      >
        <button type="button" class="pl-btn pl-btn--icon" :title="$t('excel')">
          <v-icon size="16" color="#2E7D32">mdi-file-excel-outline</v-icon>
        </button>
      </export-excel>
      <v-menu offset-y left>
        <template v-slot:activator="{ attrs, on }">
          <button type="button" class="pl-btn pl-btn--icon" v-bind="attrs" v-on="on">
            <v-icon size="16">mdi-dots-vertical</v-icon>
          </button>
        </template>
        <v-list dense>
          <v-list-item link @click="openUploadDialog">
            <v-list-item-icon>
              <v-icon>mdi-database-import-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title v-text="$t('importData')" />
          </v-list-item>
          <log
            v-if="
              $store.state.permissions && $store.state.permissions.includes('logList')
            "
            ref="logRef"
            :type-prop="typeForm"
            :listProp="true"
            mode-prop="button"
          />
          
          
          
          
        </v-list>
      </v-menu>
    </template>
    <template #bulk>
      <button
        v-if="!mobileShow"
        type="button"
        class="pl-bulk__btn pl-bulk__btn--danger"
        @click="deletDialog = true"
      >
        <v-icon size="17">mdi-trash-can-outline</v-icon>
        {{ $t("remove") }}
      </button>
    </template>
      <v-data-table
        v-if="headers"
        ref="listTable"
        v-column-resize="accountListColumnPlugins"
        v-column-drag="accountListColumnPlugins"
        v-column-pin="accountListColumnPlugins"
        v-model="selected"
        :height="mobileShow ? 323 : plTableH"
        fixed-header
        :headers="tableHeaders"
        :items="items"
        :options.sync="tableOptions"
        :server-items-length="totalItems"
        :loading="false"
        :page.sync="page"
        :hide-default-header="isMobile || mobileShow"
        multi-sort
        :show-select="showSelect"
        item-key="id"
        :footer-props="plFooterProps"
      >
        <template v-if="isMobile || mobileShow" v-slot:item="{ item, index }">
          <tr :class="{ 'mobile-show': mobileShow }">
            <td class="px-0">
              <v-list-item
                class="data-table-list-items mobile-td-list-border-primary"
                dense
              >
                <v-list-item-icon>
                  <div class="d-flex">
                    <p class="mt-1">
                      {{ +index + +1 }}
                    </p>
                    <v-menu offset-y>
                      <template v-slot:activator="{ attrs, on }">
                        <v-btn color="primary" v-bind="attrs" icon v-on="on">
                          <v-icon medium> mdi-dots-vertical </v-icon>
                        </v-btn>
                      </template>

                      <v-list dense>
                        <v-list-item link @click="edit(item)">
                          <v-list-item-icon>
                            <v-icon class="mt-2"> mdi-clipboard-edit </v-icon>
                            <v-tooltip bottom>
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  v-bind="attrs"
                                  icon
                                  small
                                  v-on="on"
                                  @click.stop.prevent="newTab('customerEdit', item)"
                                >
                                  <v-icon small color="primary">
                                    mdi-content-duplicate
                                  </v-icon>
                                </v-btn>
                              </template>
                              <span>{{ $t("newTab") }}</span>
                            </v-tooltip>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('edit')" />
                        </v-list-item>
                        <v-list-item
                          v-if="$route.name == 'academyStudentList'"
                          link
                          @click="events(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-school-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('academyEventList')" />
                        </v-list-item>
                        <v-list-item
                          v-if="$route.name == 'academyTeacherList'"
                          link
                          @click="teacherCostList(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-school-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            v-text="$t('academyTeacherSessionCostList')"
                          />
                        </v-list-item>
                        <v-list-item link @click="turnover(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-recycle-variant</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('turnover')" />
                        </v-list-item>
                        <v-list-item link @click="remainAccountSms(item)">
                          <v-list-item-icon>
                            <v-icon>mdi-message-text-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remainAccountSMS')" />
                        </v-list-item>
                        <v-list-item link @click="payment(item, 'pay')">
                          <v-list-item-icon>
                            <v-icon>mdi-credit-card-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('payCash')" />
                        </v-list-item>
                        <v-list-item link @click="payment(item, 'recieve')">
                          <v-list-item-icon>
                            <v-icon>mdi-cash</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('cashReceive')" />
                        </v-list-item>
                        <v-list-item
                          v-clipboard:copy="$baseURL + '/customer/edit/' + item.id"
                          link
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-link</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('copy-link')" />
                        </v-list-item>
                        <v-list-item
                          v-show="removePermission('account')"
                          link
                          @click="openDeleteDialog(item)"
                        >
                          <v-list-item-icon>
                            <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                          </v-list-item-icon>
                          <v-list-item-title v-text="$t('remove')" />
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title class="text-wrap">
                    {{ item.name }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-wrap">
                    <a v-if="item.phone" :href="'tel:' + item.phone">
                      <v-btn class="mx-2 px-1" dark text small color="primary">
                        {{ item.phone }}
                        <v-icon dark small style="font-size: 12px"> mdi-phone </v-icon>
                      </v-btn>
                    </a>
                    <a v-if="item.mobile" :href="'tel:' + item.mobile">
                      <v-btn class="mx-2" dark text small color="primary">
                        {{ item.mobile }}
                        <v-icon dark small style="font-size: 12px"> mdi-phone </v-icon>
                      </v-btn>
                    </a>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="item.email" class="text-wrap">
                    {{ $t("email") }} : {{ item.email }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="text-wrap">
                    <div class="pt-1">
                      <v-chip
                        v-show="item.remain && parseFloat(item.remain.remain) < 0"
                        small
                        color="blue"
                        outlined
                      >
                        {{ $t("creditor") }}
                      </v-chip>
                      <v-chip
                        v-show="item.remain && item.remain.remain > 0"
                        small
                        color="red"
                        outlined
                      >
                        {{ $t("debtor") }}
                      </v-chip>
                      <v-chip
                        v-show="item.remain && item.remain.remain == null"
                        small
                        color="green"
                        outlined
                      >
                        {{ $t("clearing") }}
                      </v-chip>
                      <v-chip
                        v-for="(tag, index) in item.tags"
                        :key="index"
                        :color="tag.color"
                        label
                        small
                        style="margin-left: 1px; margin-right: 1px"
                        class="px-1 mb-1"
                      >
                        <span class="px-1 white--text">
                          {{ tag.text }}
                        </span>
                      </v-chip>
                    </div>
                  </v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action class="ms-1">
                  <v-btn dark text small color="primary" @click="turnover(item)">
                    {{ $numberFormat(item.remain ? item.remain.remain : 0) }}
                    {{ $store.state.currencySymbol }}
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </td>
          </tr>
        </template>
        <template v-slot:item.action="{ item }">
          <div class="pl-action-cell">
            <v-menu offset-y :z-index="100">
            <template v-slot:activator="{ attrs, on }">
              <v-btn color="primary" v-bind="attrs" class="pl-action-cell__btn" icon x-small v-on="on">
                <v-icon small> mdi-dots-vertical </v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item link @click="edit(item)">
                <v-list-item-icon>
                  <v-icon class="mt-2"> mdi-clipboard-edit </v-icon>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        icon
                        small
                        v-on="on"
                        @click.stop.prevent="newTab('customerEdit', item)"
                      >
                        <v-icon small color="primary"> mdi-content-duplicate </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("newTab") }}</span>
                  </v-tooltip>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('edit')" />
              </v-list-item>
              <v-list-item
                v-if="$route.name == 'academyStudentList'"
                link
                @click="events(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-school-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('academyEventList')" />
              </v-list-item>
              <v-list-item
                v-if="$route.name == 'academyTeacherList'"
                link
                @click="teacherCostList(item)"
              >
                <v-list-item-icon>
                  <v-icon>mdi-school-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('academyTeacherSessionCostList')" />
              </v-list-item>
              <v-list-item link @click="turnover(item)">
                <v-list-item-icon>
                  <v-icon>mdi-recycle-variant</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('turnover')" />
              </v-list-item>
              <v-list-item link @click="remainAccountSms(item)">
                <v-list-item-icon>
                  <v-icon>mdi-message-text-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remainAccountSMS')" />
              </v-list-item>
              <v-list-item link @click="payment(item, 'pay')">
                <v-list-item-icon>
                  <v-icon>mdi-credit-card-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('payCash')" />
              </v-list-item>
              <v-list-item v-if="personnel" link @click="openCardDialog(item)">
                <v-list-item-icon>
                  <v-icon>mdi-account-hard-hat-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('operationUser')" />
              </v-list-item>
              <v-list-item link @click="payment(item, 'recieve')">
                <v-list-item-icon>
                  <v-icon>mdi-cash</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('cashReceive')" />
              </v-list-item>
              <v-list-item link @click="openTaskDialog(item)">
                <v-list-item-icon>
                  <v-icon>mdi-notebook-plus-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ $t("new-task") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item link @click="openTaskDialogList(item)">
                <v-list-item-icon>
                  <v-badge
                    color="error"
                    overlap
                    :content="item.taskCount"
                    :value="item.taskCount"
                  >
                    <v-icon>mdi-format-list-bulleted-square</v-icon>
                  </v-badge>
                </v-list-item-icon>
                <v-list-item-title>
                  {{ $t("tasks") }}
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-clipboard:copy="$baseURL + '/customer/edit/' + item.id" link>
                <v-list-item-icon>
                  <v-icon>mdi-link</v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('copy-link')" />
              </v-list-item>
              <log
                :title-prop="$t('history')"
                icon-prop="mdi-history"
                :listProp="true"
                :type-prop="typeForm"
                :refIdProp="item.id"
                mode-prop="button"
              />
              <v-list-item
                v-show="removePermission('account')"
                link
                @click="openDeleteDialog(item)"
              >
                <v-list-item-icon>
                  <v-icon color="pink"> mdi-trash-can-outline </v-icon>
                </v-list-item-icon>
                <v-list-item-title v-text="$t('remove')" />
              </v-list-item>
            </v-list>
          </v-menu>
            <span class="pl-action-cell__row">{{
              parseInt(items.indexOf(item)) + parseInt(from)
            }}</span>
          </div>
        </template>
        <template v-slot:item.last_status.status_id="{ item }">
          <v-chip
            v-if="item.last_status && item.last_status.status"
            :color="item.last_status.status.color"
            label
            small
            style="cursor: pointer"
            class="px-1 mb-1"
          >
            <span class="px-2 white--text">
              {{ item.last_status.status.name }}
            </span>
          </v-chip>
        </template>
        <template v-slot:item.firstname="{ item }">
          <v-container class="d-flex align-center gap-3 pa-0 ma-0" style="width: auto">
            <img :src="item?.avatar?.link || require('@/assets/Avatar.png')" />
            <v-container class="pa-0 ma-0" style="width: auto">
              <v-card-text class="d-flex align-center gap-1 pa-0">
                <span class="text-caption text-disable secondary--text"
                  >#{{ item.id }}</span
                >
                <a @click="edit(item)" class="text-body-2">
                  {{ item.firstname }} {{ item.lastname ? item.lastname : "" }}
                  {{ item.code ? "(" + item.code + ")" : "" }}
                </a>
              </v-card-text>
              <v-card-text class="pa-0 text-caption text-disable secondary--text">{{
                item.category ? item.category.name : "بدون دسته بندی"
              }}</v-card-text>
            </v-container>
          </v-container>
        </template>
        <template v-slot:item.national_code="{ item }">
          <v-card-text v-if="item.national_code" class="pa-0 text-caption">{{
            item.national_code
          }}</v-card-text>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">{{
            $t("haveNot")
          }}</v-card-text>
        </template>
        <template v-slot:item.remain="{ item }">
          <div>
            <a v-if="item.remain" @click="turnover(item)">
              <v-card-text class="pa-0 text-caption text-right">
                {{
                  item.remain
                    ? $numberFormat(item.remain.remain) + $store.state.currency.name
                    : 0
                }}
              </v-card-text>
            </a>
          </div>
          <v-card-text
            v-show="item.remain && parseFloat(item.remain.remain) < 0"
            class="pa-0 text-caption text-right"
            style="color: green"
          >
            {{ $t("creditor") }}
          </v-card-text>
          <v-card-text
            v-show="item.remain && item.remain.remain > 0"
            class="pa-0 text-caption text-right"
            style="color: red"
          >
            {{ $t("debtor") }}
          </v-card-text>
          <v-card-text
            v-show="item.remain && item.remain.remain == null"
            class="pa-0 text-caption text-right"
            style="color: green"
          >
            {{ $t("clearing") }}
          </v-card-text>
        </template>
        <template v-slot:item.connection_info="{ item }">
          <v-card-text
            v-if="item.mobile == null && item.phone == null && item.email == null"
            class="pa-0 text-caption text-disable secondary--text"
          >
            {{ $t("haveNot") }}
          </v-card-text>
          <div>
            <a
              v-if="item.mobile != null"
              :href="'tel:' + item.mobile"
              style="cursor: pointer"
              v-clipboard:copy="item.mobile"
              @click="copied"
            >
              <v-icon size="11" color="primary">mdi-phone</v-icon>
              {{ item.mobile }}
            </a>
          </div>
          <div>
            <a
              v-if="item.phone != null"
              :href="'tel:' + item.phone"
              style="cursor: pointer"
              v-clipboard:copy="item.phone"
              @click="copied"
            >
              <v-icon size="11" color="primary">mdi-phone-classic</v-icon>
              {{ item.phone }}
            </a>
          </div>
          <div>
            <a
              v-if="item.email != null"
              :href="'mailto:' + item.email"
              style="cursor: pointer"
              v-clipboard:copy="item.email"
              @click="copied"
            >
              <v-icon size="11" color="primary">mdi-email</v-icon>
              {{ item.email }}
            </a>
          </div>
        </template>
        <template v-slot:item.address="{ item }">
          <v-card-text v-if="item.address != null" class="pa-0 text-caption">
            {{ item.address }}
          </v-card-text>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">
            {{ $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.meta.branch.name="{ item }">
          <v-card-text v-if="item.meta && item.meta.branch" class="pa-0 text-caption">
            {{ item.meta.branch.name }}
          </v-card-text>
          <v-card-text v-else class="pa-0 text-caption text-disable secondary--text">
            {{ $t("haveNot") }}
          </v-card-text>
        </template>
        <template v-slot:item.content="{ item }">
          <div
            v-if="item.fin != null && item.fin.fin_code != null"
            class="d-flex align-center"
          >
            <v-card-text class="pa-0 text-caption">{{ $t("fin-id") }} : </v-card-text>
            <v-card-text
              v-if="item.fin != null && item.fin.fin_code != null"
              v-clipboard:copy="String(item.fin.fin_code || '')"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.fin.fin_code }}
            </v-card-text>
          </div>
          <div v-if="item.expire_date" class="pt-1">
            <v-chip
              label
              color="pink"
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="
                $store.state.userId === 'mWZdPLzdKg' ||
                $store.state.userId === 'LYqaQM7anj' ||
                $store.state.userId === 'z3YaOKgaxq' ||
                $store.state.userId === '4zbqlpZrap'
                  ? openExtensionDialog(item)
                  : null
              "
            >
              <span class="px-1 white--text">
                {{ $t("serviceExpireDate") }} : {{ item.expire_date }}
              </span>
            </v-chip>
          </div>
          <div v-if="item.plan_name" class="pt-1">
            <v-chip
              label
              color="primary"
              small
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
              @click="
                $store.state.userId === 'mWZdPLzdKg' ||
                $store.state.userId === 'LYqaQM7anj' ||
                $store.state.userId === 'z3YaOKgaxq'
                  ? openExtensionDialog(item)
                  : null
              "
            >
              <span class="px-1 white--text">
                {{ $t("plan-name") }} : {{ item.plan_name }}
              </span>
            </v-chip>
          </div>
          <v-card-text
            v-if="
              item.integrator.length == 0 ||
              (item.integrator.length != 0 &&
                (!item.integrator.find((item) => item.key == 'woocommerceId') ||
                  (item.integrator.find((item) => item.key == 'woocommerceId') &&
                    item.integrator.find((item) => item.key == 'woocommerceId').value ==
                      null)) &&
                item.integrator.length != 0 &&
                (!item.integrator.find((item) => item.key == 'digikalaId') ||
                  (item.integrator.find((item) => item.key == 'digikalaId') &&
                    item.integrator.find((item) => item.key == 'digikalaId').value ==
                      null)) &&
                item.integrator.length != 0 &&
                (!item.integrator.find((item) => item.key == 'sazitoId') ||
                  (item.integrator.find((item) => item.key == 'sazitoId') &&
                    item.integrator.find((item) => item.key == 'sazitoId').value ==
                      null)) &&
                item.integrator.length != 0 &&
                (!item.integrator.find((item) => item.key == 'webziId') ||
                  (item.integrator.find((item) => item.key == 'webziId') &&
                    item.integrator.find((item) => item.key == 'webziId').value ==
                      null)) &&
                item.integrator.length != 0 &&
                (!item.integrator.find((item) => item.key == 'magnetId') ||
                  (item.integrator.find((item) => item.key == 'magnetId') &&
                    item.integrator.find((item) => item.key == 'magnetId').value ==
                      null)) &&
                item.content == null &&
                item.custom_fields.length == 0 &&
                item.expire_date == null &&
                item.fin_id == null)
            "
            class="pa-0 text-caption text-disable secondary--text"
          >
            {{ $t("haveNot") }}
          </v-card-text>
          <!--woocommerce id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.woocommerceItems.length > 0 && item.woocommerceItems[0].woocommerceId
            "
          >
            <img src="@/assets/woo.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.woocommerceItems.length > 0 && item.woocommerceItems[0].woocommerceId
              "
              v-clipboard:copy="item.woocommerceItems[0].woocommerceId"
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.woocommerceItems[0].woocommerceId }}
            </v-card-text>
          </v-container>
          <!--digikala id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.integrator.length > 0 &&
              item.integrator.find((item) => item.key == 'digikalaId') &&
              item.integrator.find((item) => item.key == 'digikalaId').value != null
            "
          >
            <img src="@/assets/digikala.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.integrator.length > 0 &&
                item.integrator.find((item) => item.key == 'digikalaId') &&
                item.integrator.find((item) => item.key == 'digikalaId').value != null
              "
              v-clipboard:copy="
                item.integrator.find((item) => item.key == 'digikalaId').value
              "
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.find((item) => item.key == "digikalaId").value }}
            </v-card-text>
          </v-container>
          <!--sazito id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.integrator.length > 0 &&
              item.integrator.find((item) => item.key == 'sazitoId') &&
              item.integrator.find((item) => item.key == 'sazitoId').value != null
            "
          >
            <img src="@/assets/sazito(1).png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.integrator.length > 0 &&
                item.integrator.find((item) => item.key == 'sazitoId') &&
                item.integrator.find((item) => item.key == 'sazitoId').value != null
              "
              v-clipboard:copy="
                item.integrator.find((item) => item.key == 'sazitoId').value
              "
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.find((item) => item.key == "sazitoId").value }}
            </v-card-text>
          </v-container>
          <!--magnet id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.integrator.length > 0 &&
              item.integrator.find((item) => item.key == 'magnetId') &&
              item.integrator.find((item) => item.key == 'magnetId').value != null
            "
          >
            <img
              src="@/assets/integrators/logo-magnet.png"
              style="width: 20px; border-radius: 0"
            />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.integrator.length > 0 &&
                item.integrator.find((item) => item.key == 'magnetId') &&
                item.integrator.find((item) => item.key == 'magnetId').value != null
              "
              v-clipboard:copy="
                item.integrator.find((item) => item.key == 'magnetId').value
              "
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.find((item) => item.key == "magnetId").value }}
            </v-card-text>
          </v-container>
          <!--webzi id-->
          <v-container
            class="pa-0 d-flex align-center gap-1"
            v-if="
              item.integrator.length > 0 &&
              item.integrator.find((item) => item.key == 'webziId') &&
              item.integrator.find((item) => item.key == 'webziId').value != null
            "
          >
            <img src="@/assets/webzi.png" style="width: 20px; border-radius: 0" />
            <v-card-text class="pa-0 text-caption">{{ $t("id") }}: </v-card-text>
            <v-card-text
              v-if="
                item.integrator.length > 0 &&
                item.integrator.find((item) => item.key == 'webziId') &&
                item.integrator.find((item) => item.key == 'webziId').value != null
              "
              v-clipboard:copy="
                item.integrator.find((item) => item.key == 'webziId').value
              "
              @click="copied"
              class="pa-0 text-caption text-disable secondary--text"
              style="cursor: pointer"
            >
              {{ item.integrator.find((item) => item.key == "webziId").value }}
            </v-card-text>
          </v-container>
          <!--custom filds-->
          <div v-if="item.custom_fields" class="pt-1">
            <v-chip
              v-for="(field, index) in item.custom_fields"
              :key="index"
              label
              color="primary"
              pa-0
              text-caption
              text-disable
              secondary--text
              style="margin-left: 1px; margin-right: 1px"
              class="px-1 mb-1"
            >
              <span class="px-1 white--text"> {{ field.key }} : {{ field.value }} </span>
            </v-chip>
          </div>
          <v-card-text class="pa-0 text-caption text-disable secondary--text">
            {{
              item.content
                ? item.content.substr(0, item.deleted_at ? item.content.length : 20)
                : ""
            }}
            {{
              !item.deleted_at && item.content && item.content.length > 20 ? "..." : ""
            }}
          </v-card-text>
        </template>
        <template v-slot:item.club_credit="{ item }">
          <v-card-text class="pa-0 text-body-2">
            {{ resolveClubCredit(item) }}
          </v-card-text>
        </template>
        <template v-slot:item.tags="{ item }">
          <pl-tags :tags="item.tags || []" />
        </template>
        <template v-slot:item.user.name="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <div v-if="item.user" color="primary" dark v-bind="attrs" v-on="on">
                <v-card-text class="pa-0 text-caption">
                  {{ item.user.firstname }} {{ item.user.lastname }}
                </v-card-text>
              </div>
              <v-card-text
                v-else
                class="pa-0 text-caption text-disable secondary--text"
                >{{ $t("haveNot") }}</v-card-text
              >
            </template>
            <span>{{ item.time }}</span>
          </v-tooltip>
        </template>
        <!-- <template v-slot:item.attraction_method_id="{ item }">
          {{ (item.attraction_method ? item.attraction_method.name : '{{ $t('haveNot') }}') }}
        </template>
        <template v-slot:item.task-relation="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                color="primary"
                x-small
                class="mx-1"
                v-on="on"
                @click="openTaskDialog(item)"
              >
                {{ $t('new-task') }}
                <v-icon
                  small
                >
                  mdi-plus
                </v-icon>
              </v-btn>
            </template>
            <span>{{ $t('new-task') }}</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-badge
                color="error"
                overlap
                :content="item.taskCount"
                :value="item.taskCount"
              >
                <v-btn
                  v-if="item.taskCount > 0"
                  v-bind="attrs"
                  color="cyan"
                  x-small
                  v-on="on"
                  @click="openTaskDialogList(item)"
                >
                  {{ $t('tasks') }}
                  <v-icon small>
                    mdi-format-list-bulleted-square
                  </v-icon>
                </v-btn>
              </v-badge>
            </template>
            <span>{{ $t('tasks') }}</span>
          </v-tooltip>
        </template>
        <template v-slot:item.status="{ item }">
          <v-chip
            v-if="item.status === 'active'"
            small
            color="blue"
            outlined
          >
            {{ $t('active') }}
          </v-chip>
          <v-chip
            v-if="item.lead === 'active'"
            small
            color="orange"
            class="mx-1"
            outlined
          >
            {{ $t('lead') }}
          </v-chip>
        </template>
        <template v-slot:item.id="{ item }">
          <a @click="edit(item)">
            {{ item.id }}
          </a>
        </template>
        <template v-slot:item.rank="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                v-if="item.rank"
                class="mx-1"
                color="amber"
                text-color="brown"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  left
                  size="15"
                >
                  mdi-language-ruby
                </v-icon>
                {{ item.rank }}
              </v-chip>
              <v-card-text v-else class="pa-0 text-caption text-disable" >{{ $t('haveNot') }}</v-card-text>
            </template>
            <span>{{ $t('point') }}</span>
          </v-tooltip>
        </template> -->
        <template v-slot:body.append>
          <tr
            v-if="isMobile || mobileShow"
            :class="{ 'v-data-table__mobile-table-row': isMobile || mobileShow }"
          >
            <td
              :colspan="`${isMobile || mobileShow ? 6 : Number(showHeaders.length) - 6}`"
              :class="{ 'v-data-table__mobile-row': isMobile || mobileShow }"
            >
              <strong>{{ $t("sumRemain") }}</strong>
            </td>
            <td
              :colspan="`${isMobile || mobileShow ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile || mobileShow }"
            >
              <v-chip v-if="isMobile" color="primary" label small class="px-1 mb-1">
                <span class="px-1 white--text">
                  {{ $numberFormat(totals.amount) }}
                  {{ $store.state.currency ? $store.state.currency.symbol : "" }}
                </span>
              </v-chip>
              <div v-if="!isMobile">
                {{ $numberFormat(totals.amount) }}
                {{ $store.state.currency ? $store.state.currency.symbol : "" }}
              </div>
            </td>
            <td
              v-if="!isMobile"
              :colspan="`${isMobile || mobileShow ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile || mobileShow }"
            />
            <td
              v-if="!isMobile"
              :colspan="`${isMobile || mobileShow ? 6 : 1}`"
              :class="{ 'v-data-table__mobile-row': isMobile || mobileShow }"
            />
          </tr>
        </template>
        <template v-slot:footer.page-text="{ pageStart, pageStop, itemsLength }">
          {{ faNum(pageStart) }}–{{ faNum(pageStop) }} {{ $t("of") }} {{ faNum($numberFormat(itemsLength)) }}
        </template>
        <template v-slot:footer.prepend>
          <!-- Desktop fixed viewport: page totals sit above pagination, outside body scroll -->
          <div
            v-if="!isMobile && !mobileShow"
            class="app-list-page-totals"
          >
            <span class="app-list-page-totals__label">{{ $t("sumRemain") }}</span>
            <span
              class="app-list-page-totals__item app-list-page-totals__item--final"
            >
              <span class="app-list-page-totals__val">
                {{ $numberFormat(totals.amount) }}
                {{ $store.state.currency ? $store.state.currency.symbol : "" }}
              </span>
            </span>
          </div>
          <div class="pl-goto">
            <span>{{ $t("goToPage") }}</span>
            <input v-model.number="page" type="number" min="1" :max="pageCount" class="pl-goto__input pl-num" />
            <span class="pl-num">/ {{ faNum(pageCount) }}</span>
          </div>
        </template>
      </v-data-table>
    <print-studio
      v-model="printStudio"
      :report="plReportKey"
      :title="(titleProp ? $t(titleProp) : $t($route.name, { name: $store.state.studentLabel }))"
      :columns="plPrintCols"
      :source="plPrintSource"
      @error="serverErrorHandeler"
    />
  </pro-list-frame>
</template>

<script>
export default {
  name: "CustomerListDesktopView",
};
</script>
